var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCompetition = function SvgLogoBrandCompetition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Wettbewerbslogo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1057",
    "data-name": "Rechteck 1057",
    width: 100,
    height: 100,
    fill: "#ddd",
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_maskieren_34",
    "data-name": "Gruppe maskieren 34",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ENTEGA_Logo_RGB",
    transform: "translate(-25.973 -25.635)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10317",
    "data-name": "Pfad 10317",
    d: "M75.973,25.634a50,50,0,1,0,50,50A50.043,50.043,0,0,0,75.973,25.634Z",
    fill: "#f2ac25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Entega__x2A__Wei\\xDF_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sternchen_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10318",
    "data-name": "Pfad 10318",
    d: "M79.188,51.777l.931-6.261,8.545,1.354-1.523-8.46,6.345-1.184,1.523,8.545,7.445-4.23,3.13,5.584-7.53,4.23,6.261,5.838-4.4,4.738L93.4,55.753l-3.892,7.953-5.753-2.876,3.892-7.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Entega__x2A__Wei\\xDF_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2061",
    "data-name": "Gruppe 2061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10319",
    "data-name": "Pfad 10319",
    d: "M44.755,93.655a13.357,13.357,0,0,0,4.822-1.861l-1.015-3.046a10.677,10.677,0,0,1-3.976,1.438c-2.623.423-4.061-.254-4.653-2.792l8.883-1.607a7.545,7.545,0,0,0-.254-1.861c-.846-4.822-3.638-6.684-7.53-6.007-4.569.846-6.261,4.061-5.415,8.883C36.633,92.216,39.509,94.585,44.755,93.655Zm-5.33-8.883c-.254-2.284.338-3.3,2.284-3.638,1.607-.254,2.792.423,3.215,2.623Z",
    fill: "#96234b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10320",
    "data-name": "Pfad 10320",
    d: "M65.313,89.763l-1.692-9.729c-.677-3.807-3.046-5.5-6.345-4.907A6.567,6.567,0,0,0,53.3,77.411l-.846-1.269-2.792.677,2.707,15.228,3.976-.677-1.946-11a3.226,3.226,0,0,1,2.369-1.607c1.607-.254,2.623.254,2.876,1.946l1.692,9.729Z",
    fill: "#96234b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10321",
    "data-name": "Pfad 10321",
    d: "M73.435,75.55l-.508-2.961-3.384.592-.592-3.638-3.046.846-.085,3.469-1.861.338.508,2.961,1.692-.338L67.6,84.771c.508,2.876,2.284,4.315,5.33,3.807a6.658,6.658,0,0,0,2.538-.931L74.7,84.856a3.863,3.863,0,0,1-1.184.423c-1.184.254-1.861-.085-2.115-1.269l-1.354-7.868Z",
    fill: "#96234b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10322",
    "data-name": "Pfad 10322",
    d: "M84.179,86.717A13.357,13.357,0,0,0,89,84.856L87.986,81.81a10.677,10.677,0,0,1-3.976,1.438c-2.623.423-4.061-.254-4.653-2.792l8.883-1.607a7.545,7.545,0,0,0-.254-1.861c-.846-4.822-3.638-6.684-7.53-6.007-4.569.846-6.261,4.061-5.415,8.883C76.057,85.279,78.849,87.648,84.179,86.717Zm-5.33-8.883c-.254-2.284.338-3.3,2.284-3.638,1.607-.254,2.792.423,3.215,2.623Z",
    fill: "#96234b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10323",
    "data-name": "Pfad 10323",
    d: "M96.446,77.919c4.146-.761,5.5-2.707,4.992-5.668a4.491,4.491,0,0,0-.508-1.607l1.607-1.607-1.1-1.692L98.815,68.7a7.849,7.849,0,0,0-3.976-.169c-4.23.761-5.5,2.961-4.992,5.753a4.189,4.189,0,0,0,2.284,3.3,3.127,3.127,0,0,0-1.354,3.13,2.725,2.725,0,0,0,1.607,2.2,3.3,3.3,0,0,0-.761,2.707c.423,2.284,2.538,3.722,6.937,2.961,4.992-.846,6.684-3.13,6.176-6.176-.423-2.369-2.284-3.215-5.584-2.792l-3.638.423c-1.015.085-1.184-.592-1.184-.931a.964.964,0,0,1,.423-.931C95.177,78.088,95.77,78,96.446,77.919Zm-1.1-6.684c1.607-.254,2.284.169,2.538,1.692s-.169,2.2-1.946,2.453A1.886,1.886,0,0,1,93.4,73.688C93.147,72.25,93.655,71.489,95.347,71.235ZM98.9,82.741c1.777-.169,2.2.085,2.284.761.169.846-.423,1.523-3.3,2.03-2.03.338-2.876,0-3.046-1.1a1.729,1.729,0,0,1,.423-1.354Z",
    fill: "#96234b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10324",
    "data-name": "Pfad 10324",
    d: "M114.89,80.964l3.046-.508-1.692-9.475c-.761-4.23-2.623-5.838-7.191-5.076a13.529,13.529,0,0,0-5.076,1.946l.846,3.046a10.766,10.766,0,0,1,4.061-1.607c2.115-.338,3.046.169,3.3,1.777l.169.846a12.621,12.621,0,0,0-3.046.085c-3.469.592-5.161,2.876-4.653,5.753.592,3.469,2.961,4.484,5.584,3.976a5.2,5.2,0,0,0,3.807-2.453h.085ZM113.2,76.48c.169.761-.931,1.777-2.284,2.03-1.269.254-2.284-.085-2.538-1.523-.169-1.184.338-2.03,2.2-2.369a6.75,6.75,0,0,1,2.2-.085Z",
    fill: "#96234b"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCompetition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-competition.96676fc503287f252e4ccb9ecb8d783c.svg";